<template>
  <div id="sensorChartData" class="animated fadeIn h-100">
    <b-row class="h-100 chartarea">
      <b-col>
        <div id="Loader" v-if="LoadYn">
          <div class="spinner-bar">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <b-form @submit.prevent="getChartData">
          <div class="searchBox black-border1">
            <div>
              <div class="search-item">
                <label>프로젝트</label>
                <vue-select
                  class="select-container w200"
                  :reduce="(a) => a.value"
                  v-model="search.projectid"
                  :options="search.projectOptions"
                  @input="getStidList"
                  label="text"
                  :clearable="false"
                  required
                >
                </vue-select>
              </div>
              <div class="search-item">
                <label>구조물</label>
                <vue-select
                  class="select-container w200"
                  :reduce="(a) => a.value"
                  v-model="search.stid"
                  :options="search.stidOptions"
                  label="text"
                  :clearable="false"
                  required
                  @input="(a) => switchDataTypeOption(a)"
                >
                </vue-select>
              </div>
              <div class="search-item">
                <label>기간</label>
                <div class="search-item-group">
                  <b-form-input
                    type="date"
                    v-model="search.stDate"
                    :max="search.stMaxDate"
                    required
                    @change="setMaxDate"
                  ></b-form-input>
                  <label>~</label>
                  <b-form-input
                    type="date"
                    v-model="search.edDate"
                    :min="search.edMinDate"
                    :max="search.edMaxDate"
                    required
                  ></b-form-input>
                </div>
              </div>
              <div class="search-item">
                <label>Sample Count</label>
                <b-form-input
                  v-model="search.samplecnt"
                  required
                ></b-form-input>
              </div>
              <div class="search-item">
                <label v-show="showGnssDataType">GNSS 데이터 타입</label>
                <b-form-select
                  v-show="showGnssDataType"
                  v-model="search.gnssDataType"
                  :options="search.gnssDataTypeOptions"
                ></b-form-select>
              </div>
              <div class="search-item">
                <label>이상치 처리</label>
                <div class="search-item-group">
                  <input
                    type="checkbox"
                    v-model="isScreenOutliers"
                    :checked="isScreenOutliers"
                    style="width: 20px; margin-right: 10px"
                  />
                  <b-form-input
                    v-model="outlierThreshold"
                    style="width: 60px"
                    :disabled="!isScreenOutliers"
                  ></b-form-input>
                </div>
              </div>
            </div>

            <div>
              <div>
                <div class="search-item" v-show="showGnssDataType">
                  <label for="search-item-gnssDataType">GNSS 데이터 타입</label>
                  <b-form-select
                    id="search-item-gnssDataType"
                    v-model="search.gnssDataType"
                    :options="search.gnssDataTypeOptions"
                  ></b-form-select>
                </div>
                <div class="search-item" v-show="showTotalStationDataType">
                  <label for="search-item-totalStationDataType">광파기</label>
                  <b-form-select
                    id="search-item-totalStationDataType"
                    style="width: 80px"
                    v-model="search.totalStationAxisType"
                    :options="search.totalStationAxisTypeOptions"
                  ></b-form-select>
                  <b-form-select
                    id="search-item-totalStationDataType"
                    style="width: 100px"
                    v-model="search.totalStationDataType"
                    :options="search.totalStationDataTypeOptions"
                  ></b-form-select>
                </div>
              </div>
              <div class="button-group">
                <div id="dropdown">
                  <div>
                    <b-button
                      class="filterBtn"
                      id="filterBtn"
                      @click="toggleFilter"
                      ><i class="fas fa-filter m0"></i
                    ></b-button>
                    <b-tooltip
                      target="filterBtn"
                      triggers="hover"
                      placement="top"
                      >임계치</b-tooltip
                    >
                  </div>
                  <div id="dropdownList">
                    <div style="margin: 5px 0px 5px 0px">
                      <div class="dropdown-option">
                        <span>초기값</span>
                        <hr style="width: 50px; border-top: 3px solid #fff" />
                      </div>
                      <div class="dropdown-option">
                        <b-form-checkbox
                          v-model="checkedTreshold"
                          value="anal1"
                          @change="thresholdFilterChanged"
                        />
                        <span>ANAL1</span>
                      </div>
                      <div class="dropdown-option">
                        <b-form-checkbox
                          v-model="checkedTreshold"
                          value="anal2"
                          @change="thresholdFilterChanged"
                        />
                        <span>ANAL2</span>
                      </div>
                    </div>
                    <div
                      v-for="(item, i) in options"
                      :key="i"
                      style="margin-bottom: 5px; border-top: 1px solid #979595"
                    >
                      <div class="optionTitle">
                        <span>{{ item.name }}</span>
                      </div>
                      <div v-for="(r, j) in riskName" :key="j">
                        <div class="dropdown-option">
                          <b-form-checkbox
                            v-model="checkedTreshold"
                            :value="item.code + '_' + (j + 1)"
                            unchecked-value="null"
                            @change="thresholdFilterChanged"
                          />
                          <span>{{ r }}</span>
                          <hr
                            :id="item.code + '_' + (j + 1)"
                            style="width: 50px"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <b-button
                  id="downloadBtn"
                  class="excelBtn"
                  style="width: 60px"
                  @click="excelDownload"
                  ><i class="fas fa-download" style="margin: 0"></i
                ></b-button>
                <b-tooltip target="downloadBtn" triggers="hover" placement="top"
                  >다운로드</b-tooltip
                >
                <b-button type="submit" class="searchBtn">조회</b-button>
                <b-button
                  class="resetBtn w35 py5 px0"
                  style="border-radius: 5px"
                  @click="openSetting"
                  ><i class="fas fa-cog mr0"></i
                ></b-button>
              </div>
            </div>
          </div>
        </b-form>
        <b-card class="black-border1" body-class="h-100 p20" :style="chartCard">
          <b-row
            v-for="(item, idx) in chartData"
            :key="idx"
            :class="graphRowCnt === idx + 1 ? '' : 'pb20'"
          >
            <div
              v-if="isGNSS(item.devtype)"
              style="width: 100%; height: 100%; display: flex; overflow: hidden"
            >
              <b-col class="col-4 pr10">
                <b-card
                  class="h-100 default-border1"
                  body-class="h-100 p-0"
                  header-tag="header"
                >
                  <h6 slot="header">
                    {{ item.title + " 위도" }}
                  </h6>
                  <div
                    :id="'latitudeChart' + (idx + 1)"
                    class="graph default-border-top1"
                  ></div>
                </b-card>
              </b-col>
              <b-col class="col-4 pr10">
                <b-card
                  class="h-100 default-border1"
                  body-class="h-100 p-0"
                  header-tag="header"
                >
                  <h6 slot="header">
                    {{ item.title + " 경도" }}
                  </h6>
                  <div
                    :id="'longitudeChart' + (idx + 1)"
                    class="graph default-border-top1"
                  ></div>
                </b-card>
              </b-col>
              <b-col class="col-4">
                <b-card
                  class="h-100 default-border1"
                  body-class="h-100 p-0"
                  header-tag="header"
                >
                  <h6 slot="header">
                    {{ item.title + " 고도" }}
                  </h6>
                  <div
                    :id="'altitudeChart' + (idx + 1)"
                    class="graph default-border-top1"
                  ></div>
                </b-card>
              </b-col>
            </div>
            <div
              v-else-if="isAMTM(item.devtype)"
              style="width: 100%; height: 100%; display: flex"
            >
              <b-col class="col-12">
                <b-card
                  class="h-100 default-border1"
                  body-class="h-100 p-0"
                  header-tag="header"
                >
                  <h6 slot="header">
                    {{ item.title }}
                  </h6>
                  <div
                    :id="'displacementChart' + (idx + 1)"
                    class="graph default-border-top1 displacementChart"
                  ></div>
                </b-card>
              </b-col>
            </div>
            <div
              v-else-if="isTotalStation(item.devtype)"
              style="width: 100%; height: 100%; display: flex"
            >
              <b-col class="col-12">
                <b-card
                  class="h-100 default-border1"
                  body-class="h-100 p-0"
                  header-tag="header"
                >
                  <h6 slot="header">
                    {{ item.title }}
                  </h6>
                  <div class="totalStationChartDiv">
                    <div
                      :id="'totalStationChart' + (idx + 1)"
                      class="graph default-border-top1 totalStationChart"
                    ></div>
                  </div>
                </b-card>
              </b-col>
            </div>
            <div
              v-else-if="isCableTensionSensor(item.sensormodel)"
              style="width: 100%; height: 100%; display: flex"
            >
              <b-col class="col-6 pr10">
                <b-card
                  class="h-100 default-border1"
                  body-class="h-100 p-0"
                  header-tag="header"
                >
                  <h6 slot="header">
                    {{ item.title }}
                  </h6>
                  <div>
                    <div
                      :id="'svChart' + (idx + 1)"
                      class="graph default-border-top1"
                    ></div>
                  </div>
                </b-card>
              </b-col>
              <b-col class="col-6 pl10">
                <b-card
                  class="h-100 default-border1"
                  body-class="h-100 p-0 ofh"
                  header-tag="header"
                >
                  <h6 slot="header">
                    {{item.title + " 온도/습도"}}
                  </h6>
                  <div
                    :id="'tempChart' + (idx + 1)"
                    class="graph default-border-top1"
                  ></div>
                </b-card>
              </b-col>
            </div>
            <div v-else style="width: 100%; height: 100%; display: flex">
              <b-col
                :class="
                  item.sensormodel && item.sensormodel.includes('HR')
                    ? 'col-12'
                    : 'col-6 pr10'
                "
              >
                <b-card
                  class="h-100 default-border1"
                  body-class="h-100 p-0 ofh"
                  header-tag="header"
                >
                  <h6 slot="header">
                    {{
                      item.title +
                      (isDynamicSensor(item.devtype) ? " ANAL1/ANAL2" : " S-V")
                    }}
                  </h6>
                  <div>
                    <button
                      v-show="item.tsdb === 'Y'"
                      style="
                        position: absolute;
                        top: 0px;
                        right: 0px;
                        z-index: 2;
                        width: 40px;
                        height: 40px;
                        background-color: transparent;
                        color: #b4b7bd;
                        border: 0px;
                      "
                      v-b-tooltip.hover
                      title="통계 그래프 조회"
                      @click="showStatChart(item)"
                    >
                      <i class="fas fa-expand fa-2xl"></i>
                    </button>
                  </div>
                  <div
                    :id="
                      (isDynamicSensor(item.devtype)
                        ? 'analChart'
                        : 'svChart') +
                      (idx + 1)
                    "
                    class="graph default-border-top1"
                  ></div>
                </b-card>
              </b-col>
              <b-col
                class="col-6 pl10"
                v-show="!item.sensormodel.includes('HR')"
              >
                <b-card
                  class="h-100 default-border1"
                  body-class="h-100 p-0 ofh"
                  header-tag="header"
                >
                  <h6 slot="header">
                    {{
                      item.title +
                      (isCCD(item.devtype)
                        ? " Sampling Rate/Intensity"
                        : isDynamicSensor(item.devtype)
                        ? " 온도/습도"
                        : " 온도/습도/배터리")
                    }}
                  </h6>
                  <div
                    :id="'tempChart' + (idx + 1)"
                    class="graph default-border-top1"
                  ></div>
                </b-card>
              </b-col>
            </div>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="sensorDataChartSettingModal"
      title="Scale 설정 정보"
      title-tag="h5"
      header-class="jcc"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <sensor-data-chart-setting-modal
        settingType="AS"
        @researchChartConfig="getSensorChartConfig"
        @researchChartData="getChartData"
      ></sensor-data-chart-setting-modal>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";
import utils from "../common/utils";
import chartUtil from "../common/chartUtil";
import SensorDataChartSettingModal from "./SensorDataSettingModal";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  components: {
    SensorDataChartSettingModal,
    VueSelect,
  },
  computed: {
    ...mapGetters([
      "getUserId",
      "getUserAuth",
      "getCenterBus",
      "getTreeGridApi",
      "getAlertOptions",
      "getConfirmOptions",
      "getSelectedDataProjectid",
      "getSelectedDataStid",
      "getSelectedDataStartDate",
      "getSelectedDataEndDate",
    ]),
  },
  data() {
    return {
      riskName: ["주의", "경고", "심각"],
      risk: ["warn", "crit", "dang"],
      options: [
        {
          name: "일 변화량",
          code: "daily",
        },
        {
          name: "트랜드 변화량",
          code: "trend",
        },
        {
          name: "충격 이벤트",
          code: "impact",
        },
      ],
      checkedTreshold: [],
      isFirstCall: true,
      totalDataCount: null,
      search: {
        projectid: null,
        projectOptions: [{ value: null, text: "선택" }],
        stid: null,
        stidOptions: [{ value: null, text: "선택" }],
        stDate: null,
        edDate: null,
        stMaxDate: null,
        edMinDate: null,
        edMaxDate: null,
        samplecnt: 10,
        gnssDataType: null,
        gnssDataTypeOptions: [
          { value: null, text: "선택" },
          { value: "anal", text: "가속도" },
          { value: "gnss", text: "GPS" },
          { value: "disp", text: "변위" },
          { value: "velo", text: "속도" },
        ],
        // 광파기 축
        totalStationAxisType: "z",
        totalStationAxisTypeOptions: [
          { value: null, text: "선택" },
          { value: "x", text: "X" },
          { value: "y", text: "Y" },
          { value: "z", text: "Z" },
        ],
        // 광파기 데이터 타입(좌표값, 변화량)
        totalStationDataType: "change",
        totalStationDataTypeOptions: [
          { value: null, text: "선택" },
          { value: "coord", text: "좌표값" },
          { value: "change", text: "변화량" },
        ],
      },
      showGnssDataType: false,
      showTotalStationDataType: false,
      graphRowCnt: 0,
      chartData: [],
      thresholdData: [],
      chartCard: {
        height: "772px",
      },
      chartConfig: null,
      LoadYn: false,
      isGnss: false,
      gnssChartData: [],
      // propData: null
      isScreenOutliers: false,
      outlierThreshold: 2,
      chartRange: [],
      chartRangeList: [],
    };
  },
  created() {
    this.getSensorChartConfig();
    this.getProjectList();
  },
  beforeMount() {},
  mounted() {
    this.chartCard.height = window.innerHeight - 237 + "px";
    // this.search.minDate = moment().subtract(29, 'day').format('YYYY-MM-DD')
    this.search.stDate = moment().subtract(6, "day").format("YYYY-MM-DD");
    this.search.edDate = moment().add(0, "day").format("YYYY-MM-DD");
    this.search.stMaxDate = moment().format("YYYY-MM-DD");
    this.setMaxDate(this.search.stDate);
    this.getCenterBus.$on("resizeEvent", (param) => {
      this.resizeEvent();
    });
  },
  destroyed() {
    this.getCenterBus.$off("resizeEvent");
  },
  methods: {
    ...mapMutations([
      "setAlertTitle",
      "setConfirmTitle",
      "setSelectedDataProjectid",
      "setSelectedDataStid",
      "setSelectedDataStartDate",
      "setSelectedDataEndDate",
    ]),
    isGNSS: utils.isGNSS,
    isCCD: utils.isCCD,
    isDynamicSensor: utils.isDynamicSensor,
    isStaticSensor: utils.isStaticSensor,
    isAMTM: utils.isAMTM,
    isTotalStation: utils.isTotalStation,
    isCableTensionSensor: utils.isCableTensionSensor,
    resizeEvent() {
      this.chartCard.height = window.innerHeight - 237 + "px";
      this.redrawChart();
    },
    isRailProject() {
      // 경부고속철도 프로젝트 확인
      if (
        this.search.projectid == "P_000069" ||
        this.search.projectid == "P_000070" ||
        this.search.projectid == "P_000071"
      ) {
        return true;
      } else {
        return false;
      }
    },
    getProjectList() {
      var reqBody = {};
      this.$http
        .post("/stat/getProjectList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].projectid,
                text: data[i].projectname,
              });
            }
            this.search.projectOptions = options;
            if (this.getSelectedDataProjectid) {
              this.search.projectid = this.getSelectedDataProjectid;
              this.getStidList();
            } else this.search.projectid = null;
          } else {
            this.setAlertTitle("프로젝트 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    switchDataTypeOption(stid) {
      this.search.stidOptions.forEach((element) => {
        if (element.value === stid) {
          this.showGnssDataType = element.gnssDeviceCnt;
          this.showTotalStationDataType = element.totalStationDeviceCnt;
        }
      });
    },
    getStidList() {
      if (!this.search.projectid) {
        this.search.stidOptions = [{ value: null, text: "선택" }];
        this.search.stid = null;
        return;
      }
      var reqBody = {
        projectid: this.search.projectid,
        requestFrom: this.$router.currentRoute.name,
      };
      this.$http
        .post("/sensor/getStidList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].stid,
                text: data[i].stname,
                gnssDeviceCnt: data[i].gnssDeviceCnt,
                totalStationDeviceCnt: data[i].totalStationDeviceCnt,
              });
            }
            this.search.stidOptions = options;
            if (this.isFirstCall) {
              if (this.getSelectedDataStid) {
                this.search.stid = this.getSelectedDataStid;
              } else this.search.stid = null;
            } else this.search.stid = null;
            this.isFirstCall = false;
          } else {
            this.setAlertTitle("구조물 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getSensorChartConfig() {
      var reqBody = {
        settingtype: "AS",
      };
      this.$http
        .post("/sensor/getSensorChartConfig", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let config = res.data.data;
            this.chartConfig = config;
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setMaxDate(startDate) {
      let edMax = moment(startDate).add(3, "M").format("YYYY-MM-DD");
      if (moment(edMax).isAfter(moment().format("YYYY-MM-DD"))) {
        this.search.edMaxDate = moment().format("YYYY-MM-DD");
      } else {
        this.search.edMaxDate = edMax;
      }
      this.search.edMinDate = startDate;
      if (moment(this.search.edDate).isAfter(this.search.edMaxDate)) {
        this.search.edDate = this.search.edMaxDate;
        this.$bvToast.toast("최대 3개월 기간의 데이터를 조회할 수 있습니다", {
          title: "Warning message",
          variant: "warning",
          autoHideDelay: 4000,
          solid: true,
        });
      }
    },
    // 센서 데이터 조회
    getChartData() {
      // 설정 바꾸기 전 차트 한번이라도 조회 한 적이 없는 경우 재조회 하지 않음
      if (this.search.stid === null || this.search.samplecnt === null) return;
      var reqBody = {
        stid: this.search.stid,
        stdate: moment(this.search.stDate).format("YYYYMMDD"),
        eddate: moment(this.search.edDate).format("YYYYMMDD"),
        samplecnt: this.search.samplecnt,
        dataType: this.search.gnssDataType,
        isScreenOutliers: this.isScreenOutliers,
        outlierThreshold: this.outlierThreshold,
      };

      this.setSelectedDataProjectid(this.search.projectid);
      this.setSelectedDataStid(this.search.stid);
      this.setSelectedDataStartDate(this.search.stDate);
      this.setSelectedDataEndDate(this.search.edDate);

      this.LoadYn = true;
      this.$http
        .post("/sensor/getChartDataList", reqBody, { timeout: 10 * 60 * 1000 })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var chartData = res.data.data.data;
            this.chartRange = res.data.data.chartRange;
            this.chartRangeList = res.data.data.chartRangeList;

            // 기존 그래프 초기화(삭제) - 조회 전후 개수 달라질 경우 대비
            this.thresholdData = [];
            this.initChartGraph();
            this.chartData = [];
            this.graphRowCnt = chartData.length;
            for (let i = 0; i < chartData.length; i++) {
              // chart_data에 timestamp가 있으면 time으로 이름 변경
              if (
                chartData[i].chart_data &&
                chartData[i].chart_data.timestamp
              ) {
                chartData[i].chart_data.time =
                  chartData[i].chart_data.timestamp;
                delete chartData[i].chart_data.timestamp;
              }

              // Change Time Format
              if (chartData[i].chart_data.time != null) {
                for (let j = 0; j < chartData[i].chart_data.time.length; j++) {
                  chartData[i].chart_data.time[j] = moment(
                    chartData[i].chart_data.time[j] * 1000
                  ).format("YYYY-MM-DD HH:mm:ss");
                }
              }

              if (utils.isAMTM(chartData[i].device_type)) {
                this.chartData.push({
                  title: chartData[i].sensor_alias,
                  devtype: chartData[i].device_type,
                  data: chartData[i].chart_data,
                });
                // X/Y축에 동일한 임계치를 적용하므로 line.x(=line.y)를 그대로 사용
                const amtmThr =
                  chartData[i].line != undefined && chartData[i].line != null
                    ? chartData[i].line.x
                    : null;
                this.thresholdData.push(
                  amtmThr
                    ? {
                        daily: amtmThr.daily,
                        trend: amtmThr.trend,
                        impact: amtmThr.impact,
                        initial: amtmThr.initial,
                        thrmode: amtmThr.thrmode,
                      }
                    : {}
                );
                continue;
              }

              // 임계치 값 저장
              if (chartData[i].line != undefined && chartData[i].line != null) {
                var obj = {};
                if (this.isDynamicSensor(chartData[i].device_type) && !this.isCableTensionSensor(chartData[i].sensor_model)) {
                  obj.anal1 = chartData[i].line.anal1;
                  obj.anal2 = chartData[i].line.anal2;
                  this.thresholdData.push(obj);
                } else {
                  obj = {};
                  obj.daily = chartData[i].line.daily;
                  obj.trend = chartData[i].line.trend;
                  obj.impact = chartData[i].line.impact;
                  obj.initial = chartData[i].line.initial;
                  obj.thrmode = chartData[i].line.thrmode;
                  this.thresholdData.push(obj);
                }
              } else {
                this.thresholdData.push({});
              }

              this.chartData.push({
                title: chartData[i].sensor_alias,
                devname: utils.chkNull(chartData[i].device_name, null),
                devtype: chartData[i].device_type,
                chan: utils.chkNull(chartData[i].ch_no, null),
                data: chartData[i].chart_data,
                initval: chartData[i].init_val ? chartData[i].init_val : 0,
                thrmode: chartData[i].thrmode ? chartData[i].thrmode : null,
                line: chartData[i].line ? chartData[i].line : null,
                sensormodel: chartData[i].sensor_model,
                unit: chartData[i].unit,
                codeval: chartData[i].codeval,
                sensorIdx: chartData[i].sensorIdx,
                stid: chartData[i].stid,
              });
            }
            this.$nextTick(() => {
              this.redrawChart();
              this.LoadYn = false;
            });
          } else {
            this.LoadYn = false;
            this.setAlertTitle();
            let errorMsg = "관리자에게 문의하세요.";
            if (res.data.errormsg === "NO GNSS DATA TYPE") {
              errorMsg = "GNSS 디바이스 데이터 타입을 선택해주세요";
            }
            this.$bvModal
              .msgBoxOk(errorMsg, this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          this.LoadYn = false;
          console.error(err);
        });
    },
    initChartGraph() {
      for (let i = 0; i < this.chartData.length; i++) {
        if (this.isAMTM(this.chartData[i].devtype)) {
          Plotly.purge("displacementChart" + (i + 1));
          continue;
        }

        if (this.isTotalStation(this.chartData[i].devtype)) {
          Plotly.purge("totalStationChart" + (i + 1));
          continue;
        }

        if (this.isDynamicSensor(this.chartData[i].devtype) && !this.isCableTensionSensor(this.chartData[i].sensormodel)) {
          Plotly.purge("analChart" + (i + 1));
        } else {
          Plotly.purge("svChart" + (i + 1));
        }
        Plotly.purge("tempChart" + (i + 1));
      }
    },
    redrawChart() {
      try {
        const colors = ["#0F0", "#FF0", "#F00"];
        const lineTypes = ["daily", "trend", "impact"];
        const lineTypesKr = ["일", "트랜드", "충격"];

        const thresholdSettings = {
          daily: [
            { color: "#0F0", dash: "dot" },
            { color: "#0F0", dash: "dash" },
            { color: "#0F0", dash: null },
          ],
          trend: [
            { color: "#FF0", dash: "dot" },
            { color: "#FF0", dash: "dash" },
            { color: "#FF0", dash: null },
          ],
          impact: [
            { color: "#F00", dash: "dot" },
            { color: "#F00", dash: "dash" },
            { color: "#F00", dash: null },
          ],
        };

        for (let i = 0; i < this.chartData.length; i++) {
          let chartid = null;
          if (this.isGNSS(this.chartData[i].devtype)) {
            let chartid = null;
            chartid = "latitudeChart" + (i + 1);
            this.drawTimeLineChart(chartid, {
              x: this.chartData[i].data["time"],
              y: this.chartData[i].data["LATITUDE"],
              name: "latitude",
            });
            chartid = "longitudeChart" + (i + 1);
            this.drawTimeLineChart(chartid, {
              x: this.chartData[i].data["time"],
              y: this.chartData[i].data["LONGITUDE"],
              name: "longitude",
            });
            chartid = "altitudeChart" + (i + 1);
            this.drawTimeLineChart(chartid, {
              x: this.chartData[i].data["time"],
              y: this.chartData[i].data["ALTITUDE"],
              name: "altitude",
            });
          } else if (this.isAMTM(this.chartData[i].devtype)) {
            this.drawGroupChartAMTM(
              this.chartData[i].data,
              i,
              this.thresholdData[i]
            );
          } else if (this.isTotalStation(this.chartData[i].devtype)) {
            let dataKey =
              this.search.totalStationDataType == "change"
                ? "d" + this.search.totalStationAxisType
                : this.search.totalStationAxisType;

            // 초기값 표시
            var tmpLine = [];
            if (
              this.thresholdData[i] &&
              this.thresholdData[i].hasOwnProperty("initial") &&
              this.thresholdData[i].initial != null
            ) {
              tmpLine.push({
                name: "초기값",
                value: this.thresholdData[i].initial,
                color: "#FFF",
                dash: null,
              });
            }

            for (let k = 0; k < this.risk.length; k++) {
              for (let key in thresholdSettings) {
                const thresholdKey = key + "_" + (k + 1);

                if (
                  this.thresholdData[i] &&
                  this.thresholdData[i].hasOwnProperty("thrmode") &&
                  this.thresholdData[i].thrmode.indexOf("H") !== -1 &&
                  this.checkedTreshold.includes(thresholdKey) &&
                  this.thresholdData[i][key]["high" + (k + 1)] != null
                ) {
                  const name =
                    key == "daily" ? "일" : key == "trend" ? "트랜드" : "충격";
                  tmpLine.push({
                    name:
                      name +
                      "_" +
                      this.riskName[k] +
                      " " +
                      this.thresholdData[i][key]["high" + (k + 1)].toFixed(2),
                    value: this.thresholdData[i][key]["high" + (k + 1)],
                    color: thresholdSettings[key][k].color,
                    dash: thresholdSettings[key][k].dash,
                  });
                }

                if (
                  this.thresholdData[i] &&
                  this.thresholdData[i].hasOwnProperty("thrmode") &&
                  this.thresholdData[i].thrmode.indexOf("L") !== -1 &&
                  this.checkedTreshold.includes(thresholdKey) &&
                  this.thresholdData[i][key]["low" + (k + 1)]
                ) {
                  tmpLine.push({
                    value: this.thresholdData[i][key]["low" + (k + 1)],
                    color: thresholdSettings[key][k].color,
                    dash: thresholdSettings[key][k].dash,
                  });
                }
              }
            }

            this.drawTotalStationChart(
              "totalStationChart" + (i + 1),
              {
                x: this.chartData[i].data["time"],
                y: this.chartData[i].data[dataKey],
                name: "data",
                line: tmpLine ? tmpLine : null,
              },
              {
                xaxisTitle: "시간",
                yaxisTitle:
                  this.search.totalStationDataType == "coord"
                    ? "m"
                    : this.chartData[i].unit,
              }
            );
          } else if (this.isDynamicSensor(this.chartData[i].devtype) && !this.isCableTensionSensor(this.chartData[i].sensormodel)) {
            var tmpLine = [];
            for (let j = 0; j < 2; j++) {
              const anal = "anal" + (j + 1);
              if (this.checkedTreshold.includes(anal)) {
                // 초기값 라인 추가
                if (
                  this.thresholdData[i] &&
                  this.thresholdData[i][anal] &&
                  this.thresholdData[i][anal].hasOwnProperty("initial") &&
                  this.thresholdData[i][anal].initial != null
                ) {
                  tmpLine.push({
                    name: "초기값",
                    value: this.thresholdData[i][anal].initial,
                    color: "#FFF",
                    dash: null,
                  });
                }

                // 임계치 값이 null이 아니고 필터에 체크되어 있으면 추가
                for (let k = 0; k < this.risk.length; k++) {
                  if (this.isRailProject()) {
                    const thresholdKey = "impact_" + (k + 1);

                    if (
                      this.thresholdData[i] &&
                      this.thresholdData[i].initial &&
                      this.checkedTreshold.includes(thresholdKey)
                    ) {
                      tmpLine.push({
                        name: "충격_" + this.riskName[k],
                        value: this.thresholdData[i].initial - (k + 1),
                        color: "#F00",
                        dash: thresholdSettings["impact"][k].dash,
                      });
                    }
                  } else {
                    for (let key in thresholdSettings) {
                      const thresholdKey = key + "_" + (k + 1);
                      const name =
                        key == "daily"
                          ? "일"
                          : key == "trend"
                          ? "트랜드"
                          : "충격";

                      if (
                        this.checkedTreshold.includes(thresholdKey) &&
                        this.thresholdData[i][anal] &&
                        this.thresholdData[i][anal][key]["high" + (k + 1)] !=
                          null
                      ) {
                        tmpLine.push({
                          name:
                            name +
                            "_" +
                            this.riskName[k] +
                            " " +
                            this.thresholdData[i][anal][key]["high" + (k + 1)],
                          value:
                            this.thresholdData[i][anal][key]["high" + (k + 1)],
                          color: thresholdSettings[key][k].color,
                          dash: thresholdSettings[key][k].dash,
                        });
                      }

                      if (
                        this.checkedTreshold.includes(thresholdKey) &&
                        this.thresholdData[i][anal] &&
                        this.thresholdData[i][anal][key]["low" + (k + 1)] !=
                          null
                      ) {
                        tmpLine.push({
                          name:
                            name +
                            "_" +
                            this.riskName[k] +
                            " " +
                            this.thresholdData[i][anal][key]["low" + (k + 1)],
                          value:
                            this.thresholdData[i][anal][key]["low" + (k + 1)],
                          color: thresholdSettings[key][k].color,
                          dash: thresholdSettings[key][k].dash,
                        });
                      }
                    }
                  }
                }
              }
            }

            chartid = "analChart" + (i + 1);
            this.drawDualAxisTimeLineChart(
              chartid,
              {
                x: this.chartData[i].data["time"],
                y1: this.chartData[i].data["ANAL_1"],
                name1: "anal1",
                title1: "ANAL_1(ma.u)",
                y2: this.chartData[i].data["ANAL_2"],
                name2: "anal2",
                title2: "ANAL_2(ma.u)",
                line: tmpLine ? tmpLine : null,
                filterChecked: [
                  // 임계치 anal1, anal2 선택 여부 전달
                  this.checkedTreshold.includes("anal1") ? true : false,
                  this.checkedTreshold.includes("anal2") ? true : false,
                ],
                sensorIdx: this.chartData[i].sensorIdx,
                stid: this.chartData[i].stid,
              },
              {
                y: {
                  min: this.chartConfig.analstanal1,
                  max: this.chartConfig.analedanal1,
                },
                y2: {
                  min: this.chartConfig.analstanal2,
                  max: this.chartConfig.analedanal2,
                },
              },
              false
            );
            chartid = "tempChart" + (i + 1);

            let temperatureName = "온도";
            let temperatureTitle = "온도(°C)";
            let humidityName = "습도";
            let humidityTitle = "습도(%)";
            if (this.isCCD(this.chartData[i].devtype)) {
              temperatureName = "Sampling Rate";
              temperatureTitle = "Sampling Rate(Hz)";
              humidityName = "Intensity";
              humidityTitle = "Intensity";
            }

            this.drawDualAxisTimeLineChart(
              chartid,
              {
                x: this.chartData[i].data["time"],
                y1: this.chartData[i].data["temp"],
                name1: temperatureName,
                title1: temperatureTitle,
                y2: this.chartData[i].data["humi"],
                name2: humidityName,
                title2: humidityTitle,
              },
              {
                y: {
                  min: this.chartConfig.analsttemp,
                  max: this.chartConfig.analedtemp,
                },
                y2: {
                  min: this.chartConfig.analsthumid,
                  max: this.chartConfig.analedhumid,
                },
              },
              true
            );
          } else if (this.isStaticSensor(this.chartData[i].devtype)) {
            var tmpLine = [];

            if (
              this.thresholdData[i] &&
              this.thresholdData[i].hasOwnProperty("initial") &&
              this.thresholdData[i].initial != null
            ) {
              tmpLine.push({
                name: "초기값",
                value: this.thresholdData[i].initial,
                color: "#FFF",
                dash: null,
              });
            }

            for (let k = 0; k < this.risk.length; k++) {
              if (this.isRailProject()) {
                const thresholdKey = "impact_" + (k + 1);

                if (
                  this.thresholdData[i] &&
                  this.thresholdData[i].initial &&
                  this.checkedTreshold.includes(thresholdKey)
                ) {
                  tmpLine.push({
                    name: "충격_" + this.riskName[k],
                    value: this.thresholdData[i].initial - (k + 1),
                    color: "#F00",
                    dash: thresholdSettings["impact"][k].dash,
                  });
                }
              } else {
                for (let key in thresholdSettings) {
                  const thresholdKey = key + "_" + (k + 1);

                  if (
                    this.thresholdData[i] &&
                    this.thresholdData[i].hasOwnProperty("thrmode") &&
                    this.thresholdData[i].thrmode.indexOf("H") !== -1 &&
                    this.checkedTreshold.includes(thresholdKey) &&
                    this.thresholdData[i][key]["high" + (k + 1)] != null
                  ) {
                    const name =
                      key == "daily"
                        ? "일"
                        : key == "trend"
                        ? "트랜드"
                        : "충격";
                    tmpLine.push({
                      name:
                        name +
                        "_" +
                        this.riskName[k] +
                        " " +
                        this.thresholdData[i][key]["high" + (k + 1)].toFixed(2),
                      value: this.thresholdData[i][key]["high" + (k + 1)],
                      color: thresholdSettings[key][k].color,
                      dash: thresholdSettings[key][k].dash,
                    });
                  }

                  if (
                    this.thresholdData[i] &&
                    this.thresholdData[i].hasOwnProperty("thrmode") &&
                    this.thresholdData[i].thrmode.indexOf("L") !== -1 &&
                    this.checkedTreshold.includes(thresholdKey) &&
                    this.thresholdData[i][key]["low" + (k + 1)]
                  ) {
                    tmpLine.push({
                      value: this.thresholdData[i][key]["low" + (k + 1)],
                      color: thresholdSettings[key][k].color,
                      dash: thresholdSettings[key][k].dash,
                    });
                  }
                }
              }
            }

            chartid = "svChart" + (i + 1);
            this.drawTimeLineChart(
              chartid,
              {
                x: this.chartData[i].data["time"],
                y: this.chartData[i].data["data"],
                name: "S-V",
                // title: "S-V(a.u)",
                title:
                  this.chartData[i].codeval +
                  "(" +
                  this.chartData[i].unit +
                  ")",
                line: tmpLine ? tmpLine : null,
                sensorIdx: this.chartData[i].sensorIdx,
                stid: this.chartData[i].stid,
              },
              {
                y: {
                  min: this.chartConfig.svstsv,
                  max: this.chartConfig.svedsv,
                },
              }
            );
            chartid = "tempChart" + (i + 1);
            this.drawDualAxisTimeLineChart(
              chartid,
              {
                x: this.chartData[i].data["time"],
                y1: this.chartData[i].data["temp"],
                name1: "온도",
                title1: "온도(°C)",
                y2: this.chartData[i].data["humi"],
                name2: "습도",
                title2: "습도/배터리(%)",
                y3: this.chartData[i].data["batt"],
                name3: "배터리",
                title3: "배터리(%)",
              },
              {
                y: {
                  min: this.chartConfig.svsttemp,
                  max: this.chartConfig.svedtemp,
                },
              },
              true
            );
          } else if (this.isCableTensionSensor(this.chartData[i].sensormodel)) {
            chartid = "svChart" + (i + 1);
            this.drawTimeLineChart(
              chartid,
              {
                x: this.chartData[i].data["time"],
                y: this.chartData[i].data["data"],
                name: "장력(kN)",
                title: "장력(kN)",
                line: tmpLine ? tmpLine : null,
                sensorIdx: this.chartData[i].sensorIdx,
                stid: this.chartData[i].stid,
              },
              {
                y: {
                  min: this.chartConfig.svstsv,
                  max: this.chartConfig.svedsv,
                },
              }
            );
            chartid = "tempChart" + (i + 1);
            this.drawDualAxisTimeLineChart(
              chartid,
              {
                x: this.chartData[i].data["time"],
                y1: this.chartData[i].data["temp"],
                name1: "온도",
                title1: "온도(°C)",
                y2: this.chartData[i].data["humi"],
                name2: "습도",
                title2: "습도(%)",
              },
              {
                y: {
                  min: this.chartConfig.svsttemp,
                  max: this.chartConfig.svedtemp,
                },
              },
              true
            );
          }
        }
      } catch (err) {
        this.LoadYn = false;
        console.error(err);
      }
    },
    // x축이 시간인 라인 차트 그리기
    drawTimeLineChart(id, param, range) {
      const { dtick, dtick2, yAxisMin, yAxisMax, yAxisMin2, yAxisMax2 } =
        utils.getChartRangeValues(this.chartRangeList, this.chartRange, param);

      var Data = [
        {
          x: param.x,
          y: param.y,
          name: param.name,
          type: "scatter",
          mode: "lines",
          line: { width: 1 },
        },
      ];
      var tmpLayout = document.getElementById(id);
      let layout = {
        xaxis: {
          zeroline: false,
          color: "#b4b7bd",
          tickformat: "%Y-%m-%d %H:%M:%S",
          nticks: param.x.length > 4 ? 4 : param.x.length,
        },
        yaxis: {
          title: param.title,
          titlefont: {
            family: "Noto Sans KR",
            size: 14,
            weight: "normal",
          },
          zeroline: false,
          color: "#b4b7bd",
          nticks: param.y.length > 4 ? 4 : param.y.length,
          dtick: dtick,
          range: [yAxisMin, yAxisMax],
        },
        showlegend: true,
        legend: {
          orientation: "h",
          x: 0.45,
          xanchor: "center",
          y: -0.15,
          font: {
            color: "#b4b7bd",
          },
        },
        paper_bgcolor: "#283046",
        plot_bgcolor: "#283046",
        width: Math.floor(tmpLayout.clientWidth - 1),
        height: 302,
        margin: {
          l: 80,
          r: 50,
          t: 20,
          b: 30,
          pad: 0,
        },
        annotations: [],
      };
      /* if (utils.chkNull(range) !== null) {
        if (
          utils.chkNull(range.x) !== null &&
          (range.x.min !== 0 || range.x.max !== 0)
        ) {
          layout.xaxis.range = [range.x.min, range.x.max];
        }
        if (
          utils.chkNull(range.y) !== null &&
          (range.y.min !== 0 || range.y.max !== 0)
        ) {
          layout.yaxis.range = [range.y.min, range.y.max];
        }
      } */
      if (param.hasOwnProperty("line") && param.line !== null) {
        for (let i = 0; i < param.line.length; i++) {
          // 임계치 null 일 때 표시하지 않음
          let line = {
            x: [param.x[0], param.x[param.x.length - 1]],
            y: [param.line[i].value, param.line[i].value],
            mode: "lines",
            line: {
              color: param.line[i].color,
              width: 1,
              dash: param.line[i].dash,
            },
            name: param.line[i].name,
            showlegend: false,
          };

          if (this.isRailProject()) {
            line.showlegend = true;
          }

          Data.push(line);
        }
      }
      Plotly.newPlot(id, Data, layout, { displaylogo: false });
    },
    // x축이 시간이면서 Y축이 좌우인 라인 차트 그리기
    drawDualAxisTimeLineChart(id, param, range, isTempChart) {
      const { dtick, dtick2, yAxisMin, yAxisMax, yAxisMin2, yAxisMax2 } =
        utils.getChartRangeValues(this.chartRangeList, this.chartRange, param);

      var Data = [
        {
          x: param.x,
          y: param.y1,
          name: param.name1,
          type: "scatter",
          mode: "lines",
          line: { width: 1 },
        },
        {
          x: param.x,
          y: param.y2,
          name: param.name2,
          type: "scatter",
          mode: "lines",
          yaxis: "y2",
          line: { width: 1 },
        },
      ];
      if (param.hasOwnProperty("y3")) {
        Data.push({
          x: param.x,
          y: param.y3,
          name: param.name3,
          type: "scatter",
          mode: "lines",
          yaxis: "y2",
          line: { width: 1 },
        });
      }

      if (isTempChart) {
        Data[0].line.color = "#ff7f0e";
        Data[1].line.color = "#1f77b4";
      }

      // anal1, anal2 중에 선택된 항목의 그래프만 표시
      if (param.hasOwnProperty("filterChecked")) {
        if (param.filterChecked[0] || param.filterChecked[1]) {
          if (!param.filterChecked[0]) Data[0].visible = "legendonly";
          if (!param.filterChecked[1]) Data[1].visible = "legendonly";
        }
      }
      var tmpLayout = document.getElementById(id);
      let layout = {
        xaxis: {
          zeroline: false,
          color: "#b4b7bd",
          tickformat: "%Y-%m-%d %H:%M:%S",
          tickmode: "auto",
          nticks: param.x.length > 4 ? 4 : param.x.length,
        },
        yaxis: {
          title: param.title1,
          titlefont: {
            family: "Noto Sans KR",
            size: 14,
            weight: "normal",
          },
          zeroline: false,
          color: "#b4b7bd",
          nticks: param.y1.length > 4 ? 4 : param.y1.length,
          dtick: dtick,
          range: [yAxisMin, yAxisMax],
        },
        yaxis2: {
          title: param.title2,
          titlefont: {
            family: "Noto Sans KR",
            size: 14,
            weight: "normal",
          },
          zeroline: false,
          color: "#b4b7bd",
          overlaying: "y",
          side: "right",
          nticks: param.y2.length > 4 ? 4 : param.y2.length,
          dtick: dtick2,
          range: [yAxisMin2, yAxisMax2],
        },
        paper_bgcolor: "#283046",
        plot_bgcolor: "#283046",
        width: Math.floor(tmpLayout.clientWidth - 1),
        height: 302,
        showlegend: true,
        legend: {
          orientation: "h",
          x: 0.45,
          y: -0.15,
          xanchor: "center",
          font: {
            color: "#b4b7bd",
          },
        },
        margin: {
          l: 80,
          r: 80,
          t: 20,
          b: 30,
          pad: 0,
        },
        annotations: [],
      };
      if (param.hasOwnProperty("y3")) {
        layout.yaxis3 = {
          title: {
            text: param.title3,
            font: {
              family: "Noto Sans KR",
              size: 14,
              weight: "normal",
            },
          },
          zeroline: false,
          color: "#b4b7bd",
          overlaying: "y",
          side: "right",
          tickmode: "auto",
          nticks: param.y3.length > 4 ? 4 : param.y3.length,
        };
      }

      if (param.hasOwnProperty("line")) {
        for (let i = 0; i < param.line.length; i++) {
          // 임계치 null 일 때 표시하지 않음
          let line = {
            x: [param.x[0], param.x[param.x.length - 1]],
            y: [param.line[i].value, param.line[i].value],
            mode: "lines",
            line: {
              color: param.line[i].color,
              width: 1,
              dash: param.line[i].dash,
            },
            name: param.line[i].name,
            showlegend: false,
          };

          if (line.y[1] > 0) {
            line.showlegend = true;
          }

          Data.push(line);
        }
      }

      /* if (utils.chkNull(range) !== null) {
        if (
          utils.chkNull(range.x) !== null &&
          (range.x.min !== 0 || range.x.max !== 0)
        ) {
          layout.xaxis.range = [range.x.min, range.x.max];
        }
        if (
          utils.chkNull(range.y) !== null &&
          (range.y.min !== 0 || range.y.max !== 0)
        ) {
          layout.yaxis.range = [range.y.min, range.y.max];
        }
        if (
          utils.chkNull(range.y2) !== null &&
          (range.y2.min !== 0 || range.y2.max !== 0)
        ) {
          layout.yaxis2.range = [range.y2.min, range.y2.max];
        }
        if (
          utils.chkNull(range.y3) !== null &&
          (range.y3.min !== 0 || range.y3.max !== 0)
        ) {
          layout.yaxis3.range = [range.y3.min, range.y3.max];
        }
      } */
      Plotly.newPlot(id, Data, layout, { displaylogo: false });
    },
    // Make Chart Annotations
    setChartAnnotation(axis, param) {
      return {
        xref: "paper",
        yref: "paper",
        x: utils.chkNum(
          param.x,
          axis === "x" ? 0.5 : axis === "y" ? -0.14 : 1.05
        ),
        y: utils.chkNum(param.y, axis === "x" ? -0.15 : 0.5),
        text: param.text,
        textangle: axis === "x" ? 0 : axis === "y" ? -90 : 90,
        font: {
          family: "Open Sans",
          size: 17,
          color: "#e2e2e2",
          weight: "normal",
        },
        showarrow: false,
      };
    },
    toggleFilter() {
      var dd = document.getElementById("dropdown");
      var dl = document.getElementById("dropdownList");
      var fb = document.getElementById("filterBtn");
      if (dl.style.display === "none" || dl.style.display === "") {
        dl.style.display = "block";
        fb.style.borderRadius = "5px 5px 0px 0px";
        dd.style.width = "170px";
      } else {
        dl.style.display = "none";
        fb.style.borderRadius = "5px 5px 5px 5px";
        dd.style.width = "60px";
      }
    },
    // AMTM 그래프 그리기
    buildAmtmThresholdOverlay(threshold) {
      const shapes = [];
      const annotations = [];
      if (!threshold || !threshold.thrmode) {
        return { shapes, annotations };
      }

      const lineStyle = ["solid", "dash", "dot"];
      const types = [
        { key: "daily", color: "#0F0", label: "일" },
        { key: "trend", color: "#FF0", label: "트랜드" },
        { key: "impact", color: "#F00", label: "충격" },
      ];

      const addLine = (xaxis, yaxis, value, color, dash, text) => {
        shapes.push({
          type: "line",
          xref: xaxis,
          yref: yaxis + " domain",
          x0: value,
          x1: value,
          y0: 0,
          y1: 1,
          line: { color, width: 1, dash },
        });
        annotations.push({
          xref: xaxis,
          yref: yaxis + " domain",
          x: value,
          y: 1,
          yanchor: "bottom",
          yshift: 2,
          text,
          font: { family: "Arial", size: 10, color: "#b4b7bd" },
          showarrow: false,
        });
      };

      [
        { xaxis: "x", yaxis: "y" },
        { xaxis: "x2", yaxis: "y2" },
      ].forEach(({ xaxis, yaxis }) => {
        if (
          threshold.initial !== null &&
          threshold.initial !== undefined &&
          threshold.initial !== ""
        ) {
          addLine(xaxis, yaxis, threshold.initial, "#fff", "solid", "초기값");
        }

        types.forEach(({ key, color, label }) => {
          const target = threshold[key];
          if (!target) return;

          if (threshold.thrmode.includes("H")) {
            for (let i = 1; i <= 3; i++) {
              const v = target["high" + i];
              if (v !== null && v !== undefined && v !== "") {
                addLine(xaxis, yaxis, v, color, lineStyle[i - 1], label);
              }
            }
          }

          if (threshold.thrmode.includes("L")) {
            for (let i = 1; i <= 3; i++) {
              const v = target["low" + i];
              if (v !== null && v !== undefined && v !== "") {
                addLine(xaxis, yaxis, v, color, lineStyle[i - 1], label);
              }
            }
          }
        });
      });

      return { shapes, annotations };
    },
    drawGroupChartAMTM(sensorData, chartIndex, threshold) {
      const colors = [
        "#1f77b4",
        "#ff7f0e",
        "#2ca02c",
        "#d62728",
        "#9467bd",
        "#8c564b",
        "#e377c2",
        "#7f7f7f",
        "#bcbd22",
        "#17becf",
      ];

      // Create traces for each subplot
      const traces = [];

      // X축 변위 traces
      let tiltXData = [];
      sensorData.data.forEach((item, index) => {
        let legendName = new Date(item.time * 1000 + 9 * 60 * 60 * 1000)
          .toISOString()
          .replace("T", " ")
          .substring(5, 16);
        tiltXData.push({
          x: item.profile.map((p) => p.dispx),
          y: item.profile.map((p) => p.depth),
          name: legendName,
          type: "scatter",
          mode: "lines+markers",
          xaxis: "x",
          yaxis: "y",
          legendgroup: legendName,
          showlegend: true,
          line: { color: colors[index % colors.length] },
          marker: { color: colors[index % colors.length] },
        });
      });
      // Y축 변위 traces
      let tiltYData = [];
      sensorData.data.forEach((item, index) => {
        let legendName = new Date(item.time * 1000 + 9 * 60 * 60 * 1000)
          .toISOString()
          .replace("T", " ")
          .substring(5, 16);
        tiltYData.push({
          x: item.profile.map((p) => p.dispy),
          y: item.profile.map((p) => p.depth),
          name: legendName,
          type: "scatter",
          mode: "lines+markers",
          xaxis: "x2",
          yaxis: "y2",
          legendgroup: legendName,
          showlegend: false,
          line: { color: colors[index % colors.length] },
          marker: { color: colors[index % colors.length] },
        });
      });
      traces.push(...tiltXData, ...tiltYData);
      function getRange(data) {
        let x = data.map((item) => item.x);
        x = x.flat();
        let maxX = Math.abs(Math.max(...x));
        let minX = Math.abs(Math.min(...x));
        let absMaxX = Math.max(maxX, minX);
        let rangeX = [(absMaxX + 0.1) * -1, absMaxX + 0.1];
        let y = data.map((item) => item.y);
        y = y.flat();
        let maxY = Math.max(...y);
        let minY = Math.min(...y);
        let rangeY = [minY - 0.1, maxY > 0 ? maxY + 0.1 : 0.1];
        return { x: rangeX, y: rangeY };
      }
      let tiltXRange = getRange(tiltXData);
      let tiltYRange = getRange(tiltYData);
      let id = "displacementChart" + String(chartIndex + 1);
      let rectangle = [
        document.getElementById(id).clientWidth - 1,
        document.getElementById(id).clientHeight - 1,
      ];
      // Layout configuration
      const layout = {
        showlegend: true,
        grid: {
          rows: 1,
          columns: 2,
          pattern: "independent",
        },
        margin: { l: 70, r: 30, b: 50, t: 50, p: 10 },
        paper_bgcolor: "#283046",
        plot_bgcolor: "#283046",
        font: { color: "#b4b7bd" },
        xaxis: {
          title: { text: "변위 (mm)", standoff: 20 },
          color: "#b4b7bd",
          range: tiltXRange.x,
        },
        xaxis2: {
          title: { text: "변위 (mm)", standoff: 20 },
          color: "#b4b7bd",
          range: tiltYRange.x,
        },
        yaxis: {
          title: { text: "깊이 (m)", standoff: 20 },
          color: "#b4b7bd",
          range: tiltXRange.y,
        },
        yaxis2: {
          title: { text: "깊이 (m)", standoff: 20 },
          color: "#b4b7bd",
          range: tiltYRange.y,
        },
        annotations: [
          {
            text: "X축 변위",
            x: 0.22,
            y: 1,
            xref: "paper",
            yref: "paper",
            xanchor: "center",
            yanchor: "bottom",
            yshift: 10,
            showarrow: false,
            font: { color: "#b4b7bd", size: 16 },
          },
          {
            text: "Y축 변위",
            x: 0.78,
            y: 1,
            xref: "paper",
            yref: "paper",
            xanchor: "center",
            yanchor: "bottom",
            yshift: 10,
            showarrow: false,
            font: { color: "#b4b7bd", size: 16 },
          },
        ],
        width: rectangle[0],
        height: 700,
      };

      const { shapes, annotations } = this.buildAmtmThresholdOverlay(threshold);
      layout.shapes = shapes;
      layout.annotations.push(...annotations);

      const config = {
        responsive: true,
        displayModeBar: false,
      };

      Plotly.newPlot(id, traces, layout, config);
    },
    drawTotalStationChart(id, param, options) {
      let rectangle = [
        document.getElementById(id).clientWidth - 1,
        document.getElementById(id).clientHeight - 1,
      ];

      var data = [
        {
          x: param.x,
          y: param.y,
          name: "data",
          type: "scatter",
          mode: "lines",
        },
      ];

      const layout = {
        grid: {
          rows: 1,
          columns: 1,
          pattern: "independent",
        },
        margin: {
          l: 100,
          r: 30,
          b: 50,
          t: 50,
          p: 10,
        },
        paper_bgcolor: "#283046",
        plot_bgcolor: "#283046",
        font: { color: "#b4b7bd" },
        xaxis: {
          title: { text: options.xaxisTitle, standoff: 5 },
          zeroline: false,
          tickformat: "%m-%d %H:%M",
          color: "#b4b7bd",
        },
        yaxis: {
          title: { text: options.yaxisTitle, standoff: 5 },
          zeroline: false,
          color: "#b4b7bd",
        },
        width: rectangle[0],
        height: 302,
        autosize: true,
        showlegend: false,
      };

      const config = {
        responsive: true,
        displayModeBar: false,
      };

      if (param.hasOwnProperty("line") && param.line != null) {
        for (let i = 0; i < param.line.length; i++) {
          // 임계치 null 일 때 표시하지 않음
          if (param.line[i].value != null) {
            let line = {
              x: [param.x[0], param.x[param.x.length - 1]],
              y: [param.line[i].value, param.line[i].value],
              mode: "lines",
              line: {
                color: param.line[i].color,
                width: 1,
                dash: param.line[i].dash,
              },
              name: param.line[i].name,
              showlegend: param.line[i].name == "초기값" ? true : false,
            };

            if (this.isRailProject()) {
              line.showlegend = true;
            }

            data.push(line);
          }
        }
      }

      Plotly.newPlot(id, data, layout, config);
    },
    thresholdFilterChanged() {
      this.redrawChart();
    },
    openSetting() {
      // this.propData = {
      //   stdate: this.search.stDate,
      //   eddate: this.search.edDate,
      //   projectid: this.search.projectid,
      //   stid: this.search.stid
      // }
      this.$bvModal.show("sensorDataChartSettingModal");
    },
    excelDownload(evt) {
      if (this.chartData.length === 0) {
        this.setAlertTitle();
        this.$bvModal
          .msgBoxOk("데이터 조회 후 클릭해주세요.", this.getAlertOptions)
          .then((value) => {})
          .catch((err) => {
            console.error(err);
          });
        return;
      }
      this.LoadYn = true;
      let contents = [];
      // let bgwFirstYn = true
      // let bgwIdx = null
      for (let i = 0; i < this.chartData.length; i++) {
        /*
        if (this.chartData[i].devtype === '2') {
          let header = null
          let content = {}
          if (bgwFirstYn) {
            // 헤더 순서 셋팅
            header = Object.keys(this.chartData[i].data)
            console.log(header)
            if (header.findIndex(el => el === 'time') !== 0) {
              header.splice(header.findIndex(el => el === 'time'), 1)
              header.splice(0, 0, 'time')
            }
            console.log(header)

            // 데이터 셋팅
            for (let idx in header) {
              if (header[idx] === 'time') content[header[idx]] = this.chartData[i].data[header[idx]]
              else {
                header[idx] += '_CH' + this.chartData[i].chan
                content[header[idx]] = this.chartData[i].data[header[idx].split('_')[0]]
              }
            }
            contents.push({
              sheetName: this.chartData[i].devname,
              header: header,
              content: content
            })
            bgwFirstYn = false
            bgwIdx = i
          } else {
            header = Object.keys(this.chartData[i].data)
            header.splice(header.findIndex(el => el === 'time'), 1)
            for (let idx in header) {
              header[idx] += '_CH' + this.chartData[i].chan
              contents[bgwIdx].header.push(header[idx])
              contents[bgwIdx].content[header[idx]] = this.chartData[i].data[header[idx].split('_')[0]]
            }
          }
        } else {
          let header = Object.keys(this.chartData[i].data)
          if (header.findIndex(el => el === 'time') !== 0) {
            header.splice(header.findIndex(el => el === 'time'), 1)
            header.splice(0, 0, 'time')
          }

          contents.push({
            sheetName: this.chartData[i].title,
            header: header,
            content: this.chartData[i].data
          })
        }
        */
        if (utils.isAMTM(this.chartData[i].devtype)) {
          const amtmTitle = this.chartData[i].title;
          const amtmData = this.chartData[i].data.data;
          const kstStr = (unixSec) => {
            const d = new Date(unixSec * 1000 + 9 * 3600 * 1000);
            return d.toISOString().replace("T", " ").substring(0, 19);
          };
          if (amtmData && amtmData.length > 0) {
            // 첫번째 열: 깊이값(내림차순) 기준으로 각 측정 시간의 X/Y 변위를 2열씩 배치
            const depths = amtmData[0].profile
              .map((p) => p.depth)
              .sort((a, b) => b - a);

            const header = ["depth"];
            const content = { depth: depths };

            amtmData.forEach((entry) => {
              const timeStr = kstStr(entry.time);
              const byDepth = {};
              entry.profile.forEach((p) => {
                byDepth[p.depth] = p;
              });
              const xKey = timeStr + "(X)";
              const yKey = timeStr + "(Y)";
              header.push(xKey, yKey);
              content[xKey] = depths.map((d) => byDepth[d].dispx);
              content[yKey] = depths.map((d) => byDepth[d].dispy);
            });

            contents.push({
              sheetName: amtmTitle + " - 경사",
              header,
              content,
            });
          }
        } else {
          let header = Object.keys(this.chartData[i].data);
          const timeIdx = header.findIndex((el) => el === "time");
          if (timeIdx > 0) {
            header.splice(timeIdx, 1);
            header.splice(0, 0, "time");
          }

          contents.push({
            sheetName: this.chartData[i].title,
            header: header,
            content: this.chartData[i].data,
          });
        }
      }

      let stIdx = 0;
      for (stIdx = 0; stIdx < this.search.stidOptions.length; stIdx++) {
        if (this.search.stidOptions[stIdx].value === this.search.stid) break;
      }
      var reqBody = {
        fileName: this.search.stidOptions[stIdx].text + " 센서 데이터",
        data: contents,
      };
      this.$http
        .post("/sensor/excelDownload", reqBody, {
          responseType: "arraybuffer",
          timeout: 180000,
        })
        .then((res) => {
          this.LoadYn = false;
          utils.getExcelFile(res, reqBody.fileName);
        })
        .catch((err) => {
          this.LoadYn = false;
          console.error(err);
        });
    },
  },
};
</script>

<style lang="scss">
#sensorChartData {
  padding: 15px;
  & .card {
    & .card-header {
      padding: 10px 15px;
      & h6 {
        font-size: 14px;
        line-height: unset;
      }
    }
  }
  & .searchBox {
    flex-direction: column;
    justify-content: start;
    border-radius: 10px;
    padding: 15px;
    margin-bottom: 15px;
    gap: 10px;

    & > div {
      width: 100%;
      height: 30px;
      flex-direction: row;
      justify-content: start;

      & > div {
        display: flex;
        flex-direction: row;
        justify-content: start;
      }

      .button-group {
        display: flex;
        flex-direction: row;
        margin-left: auto;
      }
    }
    .search-item {
      display: flex;
      flex-direction: row;
      margin-right: 20px;
    }
    .search-item-group {
      display: flex;
      align-items: center;
    }
  }
  & .chartarea {
    & > .col > .card {
      & .card-header {
        padding: 10px 15px 12px;
        & h6 {
          font-size: 15px;
          line-height: unset;
          justify-content: center;
        }
      }
      & .card-body {
        overflow-y: auto;
        & .graph {
          height: 100%;
        }
      }
    }
  }

  #dropdown {
    margin-right: 10px;
    width: 60px;
    height: 100%;
    position: relative;

    input {
      margin-right: 5px;
      width: fit-content;
      zoom: 1.2;
    }

    .filterBtn {
      width: 100%;
      background-color: #3373c7 !important;
      border: none !important;
    }

    .filterBtn:focus {
      outline: none !important;
      box-shadow: none;
    }

    #dropdownList {
      display: none;
      position: absolute;
      width: 100%;
      background-color: #0c1931;
      height: fit-content;
      border-radius: 0px 0px 5px 5px;
      z-index: 1;
      top: 30px;
      color: #e9e9e9;
      border-left: 1px solid #7367f0;
      border-right: 1px solid #7367f0;
      border-bottom: 1px solid #7367f0;

      .optionTitle {
        display: flex;
        justify-content: center;
        font-weight: bold;
        background-color: #325596;
      }

      .dropdown-option {
        display: flex;
        height: 30px;
        padding-left: 10px;
        margin: 0;
        align-items: center;

        #daily_1 {
          border-top: 3px dotted #0f0;
        }
        #daily_2 {
          border-top: 3px dashed #0f0;
        }
        #daily_3 {
          border-top: 3px solid #0f0;
        }
        #trend_1 {
          border-top: 3px dotted #ff0;
        }
        #trend_2 {
          border-top: 3px dashed #ff0;
        }
        #trend_3 {
          border-top: 3px solid #ff0;
        }
        #impact_1 {
          border-top: 3px dotted #f00;
        }
        #impact_2 {
          border-top: 3px dashed #f00;
        }
        #impact_3 {
          border-top: 3px solid #f00;
        }
      }
    }
  }
  & .displacementChart {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    & .js-plotly-plot .plotly .main-svg {
      position: relative !important;
    }
  }
  & .totalStationChartDiv {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;
  }
  & .totalStationChart {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sensor/SensorDataChart.vue